<template>
  <section class="section">
    <van-row class="section-head" @click="() => {}">
      <van-col span="22">
        <h2 class="title">{{ t('donwload.ratingAndReview') }}</h2>
      </van-col>
      <van-col span="2">
        <van-icon name="arrow" size="16" color="#9ca3af" />
      </van-col>
    </van-row>

    <van-row class="summary">
      <van-col span="8">
        <div class="score-block">
          <span class="score">{{ appData.ratings.score.toFixed(1) }}</span>
          <div class="stars">
            <van-icon
              v-for="i in 5"
              :key="i"
              name="star"
              size="12"
              :color="i <= Math.round(appData.ratings.score) ? '#111827' : '#d1d5db'"
            />
          </div>
          <span class="count">{{ t('donwload.review') }}</span>
        </div>
      </van-col>
      <van-col span="16">
        <div v-for="d in [...appData.ratings.distribution].reverse()" :key="d.stars" class="bar-row">
          <span class="bar-label">{{ d.stars }}</span>
          <van-icon name="star" size="10" color="#9ca3af" />
          <van-progress :percentage="d.percentage" :show-pivot="false" color="#9ca3af" stroke-width="6" />
        </div>
      </van-col>
    </van-row>

    <h3 class="subtitle">{{ t('appStore.ratingsMostHelpful') }}</h3>

    <article v-for="review in appData.reviews" :key="review.id" class="review">
      <h4 class="review-title">{{ t(reviewFieldKey(review.i18nKey, 'title')) }}</h4>
      <div class="review-meta">
        <van-icon
          v-for="i in 5"
          :key="i"
          name="star"
          size="12"
          :color="i <= review.rating ? '#111827' : '#d1d5db'"
        />
        <span class="review-date">
          {{ t(reviewFieldKey(review.i18nKey, 'date')) }} ·
          <em>{{ t(reviewFieldKey(review.i18nKey, 'author')) }}</em>
        </span>
      </div>
      <p class="review-body">{{ t(review.comment) }}</p>
    </article>

    <van-button block round class="see-all">{{ t('appStore.ratingsSeeAll') }}</van-button>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { appData } from '@/lib/app-data';
import { reviewFieldKey } from '../i18n-keys';

const { t } = useI18n();
</script>

<style scoped>
.section {
  padding: 24px 16px 0;
}

.section-head {
  align-items: center;
  margin-bottom: 12px;
}

.title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}

.summary {
  align-items: flex-start;
}

.score-block {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.score {
  font-size: 56px;
  font-weight: 700;
  line-height: 1;
  color: #111827;
}

.stars {
  display: flex;
  margin-top: 4px;
}

.count {
  margin-top: 4px;
  font-size: 13px;
  color: #6b7280;
}

.bar-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.bar-label {
  width: 12px;
  text-align: right;
  font-size: 11px;
  color: #6b7280;
}

.bar-row :deep(.van-progress) {
  flex: 1;
}

.subtitle {
  margin: 28px 0 12px;
  font-size: 17px;
  font-weight: 600;
  color: #111827;
}

.review {
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.review:last-of-type {
  border-bottom: none;
}

.review-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

.review-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.review-date {
  font-size: 13px;
  color: #6b7280;
}

.review-body {
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 1.45;
  color: #1f2937;
}

.see-all {
  margin-top: 16px;
  background: #f3f4f6;
  border: none;
  color: #007AFF;
  font-weight: 500;
}
</style>
